<template>
  <el-menu
      :default-active='activeIndex'
      class="el-menu-vertical-demo "
      router
      >

    <el-menu-item
      :index="item.mate"
      v-for="(item, index) in noChildren"
      :key="index"
      @click="goPath(item.mate)"
    >
      <span>{{ item.name }}</span>
    </el-menu-item>

      <el-submenu
      :index="item.mate"
      v-for="item in hanChildren"
      :key="item.id"
    >
      <template slot="title">
        <span>{{ item.name }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="item in navProduct" :key="item.id" @click="toProduct(item)">{{item.label}}</el-menu-item>
        <el-menu-item
          v-for="subitem in productList"
          :key="subitem.ID"
          :index="subitem.ID.toString()"
          @click="goPath2(subitem)"
          >{{ subitem.Title }}</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    </el-menu>
</template>

<script>
export default {
  name: 'SidebarView',
  // props: ['titleBox'],
  data () {
    return {
      activeIndex: '/home',
      productList: [],
      navProduct: [
        { label: '全部产品列表', path: '/productMainList', id: 107 },
        { label: '仓储精细化管理系统', path: '/wmsView', id: 101 },
        { label: 'TMS运输管理系统', path: '/tmsView', id: 102 },
        { label: 'ERP管理系统', path: '/repView', id: 103 },
        { label: 'OMS管理系统', path: '/omsView', id: 108 },
        { label: '时空业务中台', path: '/middleView', id: 104 },
        { label: '电子商务平台', path: '/commerce', id: 105 },
        { label: '流通行业信息整体化架构', path: '/circulateView', id: 106 }
      ],
      titleBox: [
        { name: '走进时空', mate: '/', id: 500, itemDown: false },
        { name: '关于时空', mate: '/aboutUs', id: 501, itemDown: false },
        { name: '解决方案', mate: '/solve', id: 502, itemDown: false },
        { name: '客户案例', mate: '/case', id: 503, itemDown: false },
        { name: '新闻中心', mate: '/newsCenter', id: 504, itemDown: false },
        { name: '联系我们', mate: '/ContactUs', id: 505, itemDown: false },
        { name: '产品下载', mate: '/productMain', id: 506, itemDown: false },
        {
          name: '产品中心',
          mate: '/productMainList',
          id: 300,
          child: [
            { name: '仓储WMS系统', mate: '/wmsView', id: 31 },
            { name: 'ERP管理系统', mate: '/repView', id: 32 },
            { name: 'TMS运输管理系统', mate: '/tmsView', id: 33 },
            { name: '电子商务平台', mate: '/commerce', id: 34 },
            { name: '时空业务中台产品', mate: '/middleView', id: 35 },
            { name: '流通行业信息化整体架构', mate: '/circulateView', id: 36 },
            { name: '软件下载中心', mate: '/productMain', id: 37 }
          ],
          itemDown: false
        }

      ]
    }
  },
  // 过滤数据navList
  computed: {
    noChildren () {
      return this.titleBox.filter(item => !item.child)
    },
    hanChildren () {
      return this.titleBox.filter(item => item.child)
    }

  },
  mounted () {
    this.activeIndex = localStorage.getItem('index') ? localStorage.getItem('index') : '/home'
    this.productList = this.$store.state.productList
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      this.activeIndex = key
      localStorage.setItem('index', this.activeIndex)
    },

    // 关闭弹出层
    goPath (item) {
      localStorage.setItem('index', item)
      this.$router.push(item)
      if (this.$store.state.homePopShow === true) {
        this.$store.commit('getHomePopShow', false)
      }
    },
    // 关闭弹出层
    goPath2 (item) {
      if (this.$store.state.homePopShow === true) {
        this.$store.commit('getHomePopShow', false)
      }
      this.$router.push({ path: `/productItemShow/${item.ID}` })
    },
    toProduct (item) {
      this.$router.push(item.path)
      if (this.$store.state.homePopShow === true) {
        this.$store.commit('getHomePopShow', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.boxMenu{
  width: 100%;
  height: 100%;
  z-index: 993;
  position: relative;
}
.el-menu-vertical-demo{
  position: absolute;
  top: 0;
  z-index: 999;
}
.el-menu{
  width: 530px;
   ::v-deep .el-submenu__title{
    display: flex;
    height: 110px;
     font-size: 30px;
     flex-direction:column-reverse;
      justify-content: center;
      border-bottom:1px solid #EAF0F4;
      border-top:1px solid #EAF0F4;
    span{
      display: inline-flex;
      flex-direction:column-reverse;
      justify-content: center;
    }
    i{
      font-size: 40px;
    }
  }
  .el-menu-item{
    display: flex;
     height: 110px;
     font-size: 30px;
     flex-direction:column-reverse;
      justify-content: center;
      border-bottom:1px solid #EAF0F4;
  }
  .el-submenu__icon-arrow .el-icon-arrow-down{
    width: 35px;
    height: 35px;
  }
}

</style>
